


// Angular
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
// 3rdparty
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom, Subscription } from 'rxjs';

// Hostware
import SessionStorage from '@app/helpers/SessionStorage';
import { BottomBarService } from '@app/services/bottom-bar.service';
import { HeaderService } from '@app/services/header.service';
import { Language } from '../../../../../froexishared/src/dto/Language'

import { LanguageService } from '../../../../../froexishared/src/services/language.service';
import AvailableLanguages, { LngCodes } from "../../../../../froexishared/src/AvailableLanguages"
import LicenceOptions from '@app/helpers/Options';
import { HttpClient } from '@angular/common/http';
import { HwComputerVisionService } from '@app/services/hw-computer-vision.service';
import { BrandingDto } from '../../../../../froexishared/src/dto/BrandingDto';
import HwUtils from '@app/helpers/HwUtils';
import LocalStorage from '@app/helpers/LocalStorage';
import { MatDialog } from '@angular/material/dialog';
import { DesktopWarningDialogComponent } from '@app/dialogs/desktop-warning-dialog/desktop-warning-dialog.component';
import PhotoHelper from '@app/helpers/PhotoHelper';
import { DocumentReadModes } from '@app/enums/DocumentReadModes';
import { SwUpdate } from '@angular/service-worker';
import { HwLogDto } from '@app/dto/HwLogDto';
import { log } from 'console';
import { LogService } from '@app/services/log.service';
import { VersionService } from '@app/services/version.service';
import { SignatureDialogComponent } from '@app/dialogs/signature-dialog/signature-dialog.component';
@Component({
  selector: 'language-selection',
  templateUrl: './language-selection.component.html',
  styleUrls: ['./language-selection.component.scss']
})
export class LanguageSelectionComponent implements OnInit, OnDestroy {

  hasExiLicence = LicenceOptions.HasExiLicence
  hasExoLicence = LicenceOptions.HasExoLicence
  loadLanguages$: Subscription;
  branding: BrandingDto;
  version: string;
  languages: LngCodes[] = [
    // {lngCode:"hu",lngName: "Magyar"},
    // {lngCode:"en",lngName: "English"},
    // {lngCode:"de",lngName: "Deutsch"},
    // {lngCode:"fr",lngName: "Français"},
    // {lngCode:"ru",lngName: "Русский"},
    // {lngCode:"ro",lngName: "Română"},
    // {lngCode:"sk",lngName: "Slovenská"},

  ];
  constructor(
    private translate: TranslateService,
    private router: Router,
    private bottomBarService: BottomBarService,
    private headerService: HeaderService,
    private languageSeervice: LanguageService,
    private hw: HwComputerVisionService,
    private dialog: MatDialog,
    private  swUpdate: SwUpdate,
    private logService: LogService,
    private versionService: VersionService
  ) {
    this.branding = SessionStorage.BrandingData;

  }

  async ngOnInit() {

    this.loadLanguages();
     this.swUpdate.versionUpdates.subscribe(evt => {
        let a=3; // hash miatt kell
        let logItem : HwLogDto = new HwLogDto();
        logItem.LogLevel = "INFO";
        logItem.Subsystem = "EXI";
        logItem.Subscriber = HwUtils.getSubscriber();
        logItem.HotelId = HwUtils.getHotelId();
        logItem.UserName = "SYSTEM";
        logItem.ClassName = "SWUPDATE";
        logItem.MethodName = "VERSION_UPDATES";
        switch (evt.type) {
           case 'VERSION_DETECTED':
             logItem.Message = `Downloading new app version: ${evt.version.hash}`;
             console.log(`Downloading new app version: ${evt.version.hash}`);
             this.logService.WriteLogItem(logItem).subscribe();
             break;
           case 'VERSION_READY':
             logItem.Message = `New app version ready for use: ${evt.latestVersion.hash}`;
             console.log(`Current app version: ${evt.currentVersion.hash}`);
             console.log(`New app version ready for use: ${evt.latestVersion.hash}`);
               this.logService.WriteLogItem(logItem).subscribe(()=>{
                document.location.reload();
               });
             break;
           case 'VERSION_INSTALLATION_FAILED':
            logItem.Message = `Failed to install app version '${evt.version.hash}': ${evt.error}`;
             this.logService.WriteLogItem(logItem).subscribe()
             // const dialogRef = this.dialog.open(GenericMessageDialogComponent, {
             //   disableClose: true,
             //   hasBackdrop: true,
             //   width: "auto",
             //   data: messageData
             // })
             // console.error(`Failed to install app version '${evt.version.hash}': ${evt.error}`);
             // break;
         }
       })
      const  res = await firstValueFrom(this.versionService.getVersion());
      this.version = res.split("#")[0];
  }

  ngOnDestroy(): void {

  }

  setLanguage(lngCode: string) {
    SessionStorage.ActiveLanguage = lngCode;
    this.translate.setDefaultLang(lngCode)

    this.translate.use(lngCode).subscribe(() => {
      // const dialogRef = this.dialog.open(SignatureDialogComponent,
      //   {
      //     disableClose: true,
      //     hasBackdrop: true,
      //   })
      if (LocalStorage.IsTabletMode) {
        if (LocalStorage.OperationMode == "VIP") {
          this.router.navigateByUrl('/welcome');
        } else {
          if (SessionStorage.PhotoInTabletApp == DocumentReadModes.NO_PHOTO) {
            this.router.navigateByUrl('/vizadata');
          } else {
            this.router.navigateByUrl('/ageselection');
          }
        }
      } else {

        this.dialog.open(DesktopWarningDialogComponent, {
          disableClose: true,
          minWidth: SessionStorage.IsMobile ? "100vw" : "27vw",
          maxWidth: SessionStorage.IsMobile ? "100vw" : "27vw",
          minHeight: "27vh",
          width: "auto"
        }).afterClosed().subscribe(result => {
          this.router.navigateByUrl('/welcome');
        })

      }
    })

    // navigate to ...
  }

  loadLanguages() {
    this.loadLanguages$ = this.languageSeervice.loadAll(HwUtils.getSubscriber(), HwUtils.getHotelId()).subscribe(result => {
      const lngArr = result as string[];
      const browserLanguage = this.translate.getBrowserLang();
      this.bottomBarService.setBottomBarVisibility(true);

      if (this.languages.find(item => item.lngCode == browserLanguage)) {
        this.translate.use(browserLanguage)
      } else {
        this.translate.use("en")
      }
      this.headerService.setNavigationVisibility(false);
      if (lngArr) {
        lngArr.forEach(item => {
          this.languages.push(AvailableLanguages.Languages.find(lng => lng.lngCode == item))
        })
      } else {
        // alert("No language files installed")
      }
    })
  }

}
